<template>
  <div>
    <!-- <keep-alive> -->
      <router-view></router-view>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        slug: ''
      }
    },
    watch: {
      // '$route' (to, from) {
      //   window.console.log("监听到路由变化")
      //   window.console.log(this.$route.name)
      //   if (this.$route.name == 'UserCenter') {
      //     window.console.log("准备跳转到UserCenter")
      //     this.activeIndex = 4
      //   }
      //   window.console.log(to)
      //   window.console.log(from)
      // }
    },
    mounted () {
      this.slug = this.$route.params.slug
    }
  }
</script>

<style lang="css" scoped>
</style>
